module.exports = __webpack_public_path__ + "media/store/images/facebook-62c54ac3a7c6ea9fefe50c522c6d7284.svg";